const formatEmail = (value?: string): string => {
  if (!value) return "";

  return value.toLocaleLowerCase();
};

export default formatEmail;
